export const responseDataLakeSubscription = {
  data: {
    type: 'Subscription',
    id: '222',
    attributes: {
      price: 0,
      status: 'active',
      date_start: '2021-12-21T11:38:01',
      date_end: '2021-12-21T11:38:01',
      auto_renew: 1,
      created_at: '2021-12-21T11:38:05.367575',
      modified_at: '2021-12-21T11:38:07.188947',
      quantity: 1,
      stripe_subscription_id: '',
      name: 'data-lake-mock-1',
      rabbit_payload_successful: 0,
      primary_job_id: null,
      pipeline: null,
      invalid_subscription: 0,
      invalidated_at: null,
      notified_at: null,
      canonical_name: null,
      account_id: 431,
      product_id: 47,
      product_plan_id: null,
      remote_identity_id: null,
      storage_group_id: 143,
      user_id: 398,
      history_requested: 0
    },
    relationships: {
      account: {
        data: {
          type: 'Account',
          id: '431'
        }
      },
      product: {
        data: {
          type: 'Product',
          id: '47'
        }
      },
      product_plan: {
        data: null
      },
      remote_identity: {
        data: null
      },
      storage_group: {
        data: {
          type: 'StorageGroup',
          id: '143'
        }
      },
      user: {
        data: {
          type: 'User',
          id: '398'
        }
      }
    }
  },
  included: [
    {
      type: 'StorageGroup',
      id: '143',
      attributes: {
        product_id: 47,
        name: 'data-lake-mock-1',
        key_name: 'a404e8db3047b06b-data-lake-mock-1'
      }
    }
  ]
};